import {lazy} from '@aboutyou/lazy-imports';

export const DiscoverActivity = lazy(() =>
  import('./DiscoverActivity.eager').then(mod => ({
    default: mod.DiscoverActivity,
  })),
);
